import React from "react";
import EmptyCaseDialogMessage from "../../EmptyCaseDialogMessage";

interface PoolsEmptyStateProps {
  emptyTitle?: string;
  emptyMessage?: string;
}

const PoolsEmptyStateCard: React.FC<PoolsEmptyStateProps> = ({
  emptyTitle,
  emptyMessage
}) => (
  <EmptyCaseDialogMessage
    title={emptyTitle || "No pools available"}
    description={
      emptyMessage ||
      "There are no available pools at the moment. Check back later."
    }
    qaLabel="pools-empty-state"
    iconName="bets"
  />
);

export default PoolsEmptyStateCard;
